import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormatValidator, MaxLengthValidator, MaxValidator, MinValidator, ConstraintsValidator } from './validation.directive';

import { PgUiElementsModule } from '../pg-ui-elements/pg-ui-elements.module';
import { PgSelectComponent } from './pg-select/pg-select.component';
import { PgSwitchComponent } from './pg-switch/pg-switch.component';
import { PgRecipientComponent } from './pg-recipient/pg-recipient.component';
import { ValidationService } from './validation.service';
import { PgPhoneComponent } from './pg-phone/pg-phone.component';
import { PgEmailComponent } from './pg-email/pg-email.component';

@NgModule({
    declarations: [
        FormatValidator,
        MinValidator,
        MaxValidator,
        MaxLengthValidator,
        ConstraintsValidator,
        PgSwitchComponent,
        PgSelectComponent,
        PgRecipientComponent,
        PgPhoneComponent,
        PgEmailComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        PgUiElementsModule
    ],
    exports: [
        FormatValidator,
        MinValidator,
        MaxValidator,
        MaxLengthValidator,
        ConstraintsValidator,
        PgSwitchComponent,
        PgSelectComponent,
        PgRecipientComponent,
        PgPhoneComponent,
        PgEmailComponent
    ],
    providers: [
        ValidationService
    ]
})
export class PgUiControlsModule { }
